import FieldLabel from '@/components/form/fields/FieldLabel';
import { FunctionComponent } from 'react';
import { StandardisedProduct } from './StockProvisionPage';
import { StockProvisionStandardProductTable } from './StockProvisionStandardProductTable';

interface StockProvisionStandarisedProductSelectionProps {
  products: StandardisedProduct[];
  onChangeCallback: (productId: string, count: number) => void;
}

const StockProvisionStandarisedProductSelection: FunctionComponent<StockProvisionStandarisedProductSelectionProps> = ({
  products,
  onChangeCallback
}) => {
  return (
    <div className="space-y-1">
      <FieldLabel id={'standardProductSelector'} label={'Standardised Products'} />
      <StockProvisionStandardProductTable products={products} onChangeCallback={onChangeCallback} />
    </div>
  );
};

export default StockProvisionStandarisedProductSelection;
